import { useFeatureFlags } from 'features/project'
import { useProjectList } from 'features/project/hooks/use-project-list'
import { useProjectStore } from 'features/project/store'
import { ProjectState } from 'types/project'

export function useProjectLayoutState(): {
  projectId: string
  details: ProjectState['details']
  feature_flags: unknown
  projectsData: unknown
} {
  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const details = useProjectStore((state: ProjectState) => state.details)
  const { data: feature_flags } = useFeatureFlags()
  const { data: projectsData } = useProjectList()

  return { projectId, details, feature_flags, projectsData }
}
